var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('iv-view-area',[_c('p',[_vm._v("Left Blank for Further Usage")])])
}
var staticRenderFns = []

export { render, staticRenderFns }